import { useState } from "react";

export type SavingStatus = {
    isSaving: boolean;
    setSaving: (value: boolean) => void;

    isError: boolean;
    setError: (value: boolean) => void;

    text: {
        syncingMessage: string;
        savingDefaultMessage: string;
        errorDefaultMessage: string;
    };
};

type Options = {
    defaultIsSaving?: boolean;
    defaultIsError?: boolean;
};
export const useSavingStatus = (options?: Options) => {
    const { defaultIsSaving = false, defaultIsError = false } = options || {};

    const [isSaving, setSaving] = useState(defaultIsSaving);
    const [isError, setError] = useState(defaultIsError);

    return {
        isSaving: isSaving,
        setSaving: setSaving,
        isError: isError,
        setError: setError,
        text: {
            syncingMessage: "Synchronisation...",
            savingDefaultMessage: "Sauvegarde",
            errorDefaultMessage: "Erreur",
        },
    };
};
